import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseApiTemplateService, Core2Config } from "../../shared";
import { WebsiteFiLableListLinkContainerModel } from "../../../../../../models/aggregates/cms/website/website-fi-label-list-link-container.model";

@Injectable({ providedIn: "root" })
export class WebsiteFiLableListLinkService extends BaseApiTemplateService<WebsiteFiLableListLinkContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.CMS_PREFIX +
      "label-list-links";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.CMS_PREFIX +
      "label-list-links";
    this.httpClient = http;
  }
}
